// 📁 src/context/AuthContext.jsx (VERSIÓN FINAL OPTIMIZADA)

import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import apiClient from "../services/apiClient";

const AuthContext = createContext(null);

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) throw new Error("useAuth debe ser usado dentro de un AuthProvider");
    return context;
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    const isAdmin = user?.role === 'admin';
    const isStudent = user?.role === 'student';
    const isTeacher = user?.role === 'teacher';

    const logout = useCallback(() => {
        localStorage.removeItem("token");
        apiClient.defaults.headers.common['Authorization'] = '';
        setToken(null);
        setUser(null);
        setIsAuthenticated(false);
    }, []);

    useEffect(() => {
        const checkLoggedIn = async () => {
            const existingToken = localStorage.getItem("token");
            if (existingToken) {
                setToken(existingToken);
                apiClient.defaults.headers.common['Authorization'] = `Bearer ${existingToken}`;
                try {
                    const response = await apiClient.get("/user");
                    if (response.data?.user) {
                        setUser(response.data.user);
                        setIsAuthenticated(true);
                    } else {
                        logout();
                    }
                } catch (error) {
                    console.error("AuthContext: Fallo al verificar el token, cerrando sesión.", error.message);
                    logout();
                }
            }
            setLoading(false);
        };
        checkLoggedIn();
    }, [logout]);

    const login = useCallback((userData, tokenValue) => {
        localStorage.setItem("token", tokenValue);
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${tokenValue}`;
        setToken(tokenValue);
        setUser(userData);
        setIsAuthenticated(true);
    }, []);

    const value = {
        user,
        token,
        isAuthenticated,
        loading,
        login,
        logout,
        isAdmin,
        isStudent,
        isTeacher
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
            </AuthContext.Provider>
        );
    }